const url = window.SIMPL.blobUrl;
const params = window.SIMPL.blobParams;

export default function blobPath(resourceUrl) {
    if (resourceUrl === null){
        return null;    
    }
    return url + resourceUrl + params;
}